module.exports = __webpack_public_path__ + "img/dubi_yes.af123b08.png";